/**
 * The envelopes at the figure's feet, as geometry (BanyanScene draws them
 * from this; scene units, ground y = 600, the figure centred on viewerX).
 * Up to three are shown, each 14 to the right of and 6 above the one below,
 * the stack nudged 5 left per extra envelope so it stays by the figure. The
 * pile is not squashed with the canopy on a narrow screen: it keeps to the
 * figure, which does not move either.
 */
export interface LetterPile {
  /** One envelope's width and height. */
  w: number;
  h: number;
  /** The bottom envelope's top-left, before the per-envelope offset. */
  x0: number;
  y0: number;
  /** How many are drawn (at most three). */
  shown: number;
  /** The drawn pile's extent. */
  left: number;
  right: number;
  top: number;
  /** Where the red count sits: the top envelope's corner. */
  badge: { x: number; y: number };
}

export function letterPile(figure: number, count: number, { viewerX = 280, ground = 600 } = {}): LetterPile {
  const w = figure * 0.27;
  const h = w * 0.7;
  const x0 = viewerX + figure * 0.42;
  const y0 = ground - h - 4;
  const shown = Math.max(1, Math.min(3, count));
  const top = shown - 1;
  const shift = (shown - 1) * 5;
  return {
    w, h, x0, y0, shown,
    left: x0 - shift,
    right: x0 + top * 14 - shift + w,
    top: y0 - top * 6,
    badge: { x: x0 + top * 14 - shift + w - 3, y: y0 - top * 6 + 1 },
  };
}

/**
 * Where Ember sits when a letter someone is waiting on lies sealed in the
 * pile (2026-09-29 拍板, after the first look on a phone: standing beside the
 * pile, Ember landed inside it — the canopy's squash drew it toward the
 * figure while the pile stays put — and the envelopes covered half of it,
 * with no room beside the pile on a phone's width). It sits on the top
 * envelope, centred on the pile, a little smaller than when it walks; the
 * envelopes and the red count are drawn in front of it, so its feet tuck
 * behind the top edge. `x`, `y` are its feet, `w` its width (height 1.2 w).
 */
export function letterPerch(pile: LetterPile): { x: number; y: number; w: number } {
  const w = 62;
  return { x: (pile.left + pile.right) / 2, y: pile.top + 5, w };
}
